export default __webpack_public_path__ + "static/grouped-bar-9cc6d887f181b662965d4fbe8cae3008.png";